import { render, staticRenderFns } from "./multipletext.vue?vue&type=template&id=93fe4c02&"
import script from "./multipletext.vue?vue&type=script&lang=ts&"
export * from "./multipletext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93fe4c02')) {
      api.createRecord('93fe4c02', component.options)
    } else {
      api.reload('93fe4c02', component.options)
    }
    module.hot.accept("./multipletext.vue?vue&type=template&id=93fe4c02&", function () {
      api.rerender('93fe4c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/multipletext.vue"
export default component.exports